import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=35f8c19e&scoped=true&"
import script from "./Blank.vue?vue&type=script&lang=js&"
export * from "./Blank.vue?vue&type=script&lang=js&"
import style0 from "./Blank.vue?vue&type=style&index=0&id=35f8c19e&lang=scss&scoped=true&"
import style1 from "./Blank.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f8c19e",
  null
  
)

export default component.exports